module.exports = __webpack_public_path__ + "media/images/lp_flow-2-706c248ea461de5fc2619c24bef7df45.webp";